import { db } from "../firebase/config";

const createProfile = async (userID: string, data: any) => {
  try {
    await db.collection("profiles").doc(userID).set(data, { merge: true });
  } catch (error) {
    throw error;
  }
};

export default createProfile;
